module.exports = __webpack_public_path__ + "images/psp/ATV/10x15.svg";